import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * handles postMessage from push SW (notificationclick) to navigate SPA
 */
const ServiceWorkerNavBridge: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (event.data?.type === "NAVIGATE" && typeof event.data.url === "string") {
        const url = event.data.url as string;
        if (url.startsWith("http")) {
          try {
            const path = new URL(url).pathname + new URL(url).search + new URL(url).hash;
            navigate(path);
          } catch {
            navigate("/");
          }
        } else {
          navigate(url);
        }
      }
    };
    navigator.serviceWorker?.addEventListener("message", onMessage);
    return () => navigator.serviceWorker?.removeEventListener("message", onMessage);
  }, [navigate]);

  return null;
};

export default ServiceWorkerNavBridge;
